// import React from "react";
// import { Button } from "@/components/ui/button";
// import { Link, useNavigate } from "react-router-dom";
// import mainlogo from "@/assets/mylistiq-logo-new.png";

// const Navbar: React.FC = () => {
//   const navigate = useNavigate();

//   return (
//     <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
//       <div className="mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex h-16 items-center justify-between">
//           {/* Logo */}
//           <div
//             className="flex items-center cursor-pointer"
//             onClick={() => navigate("/")}
//           >
//             <img
//               src={mainlogo}
//               alt="MyListIQ - Easy. Affordable. Smarter."
//               className="h-12 w-auto"
//             />
//           </div>

//           {/* Navigation Links */}
//           <nav className="hidden md:flex items-center space-x-8">

//             <a
//               href="/"
//               className="text-muted-foreground hover:text-primary transition-colors"
//             >
//               Features
//             </a>
//             <a
//               href="/"
//               className="text-muted-foreground hover:text-primary transition-colors"
//             >
//               Pricing
//             </a>
//             <a
//               href="/about"
//               className="text-muted-foreground hover:text-primary transition-colors"
//             >
//               About
//             </a>

//           </nav>

//           {/* Dashboard / Login Button */}
//           <Button asChild variant="cta" size="sm">
//             <Link to={localStorage.getItem("access_token")? "/dashboard": "/login"
//               }
//             >
//               {localStorage.getItem("access_token")
//                 ? "Dashboard"
//                 : "Sign In to Dashboard"}
//             </Link>
//           </Button>

          


//         </div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;






import React from "react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import mainlogo from "@/assets/mylistiq-logo-new.png";

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">

          {/* Logo */}
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src={mainlogo}
              alt="MyListIQ - Easy. Affordable. Smarter."
              className="h-12 w-auto"
            />
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="/"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Features
            </a>
            <a
              href="/"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Pricing
            </a>
            <a
              href="/about"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              About
            </a>
          </nav>

          {/* Buttons Group */}
          <div className="flex items-center gap-4">

                     {/* Dashboard / Login - Blue Gradient */}
            <Button
              asChild
              size="sm"
              className="
                text-base font-semibold
                bg-gradient-to-r from-blue-600 to-indigo-600
                hover:from-blue-700 hover:to-indigo-700
                text-white
                shadow-md hover:shadow-xl
                transition-all duration-300
              "
            >
              <Link
                to={localStorage.getItem("access_token") ? "/dashboard" : "/signup"}
              >
                {localStorage.getItem("access_token")
                  ? "Dashboard"
                  : "Sign In to Dashboard"}
              </Link>
            </Button>



            {/* Beta Agreement - Solid Red */}
            <Button
              asChild
              size="sm"
              className="
                text-base font-semibold
                bg-red-600
                hover:bg-red-700
                text-white
                shadow-md hover:shadow-xl
                transition-all duration-300
              "
            >
              <Link to="/beta-agreement">Beta Agreement</Link>
            </Button>

            {/* Beta Checklist - Solid Red */}
            <Button
              asChild
              size="sm"
              className="
                text-base font-semibold
                bg-red-600
                hover:bg-red-700
                text-white
                shadow-md hover:shadow-xl
                transition-all duration-300
              "
            >
              <Link to="/beta-checklist">Beta Checklist</Link>
            </Button>

 
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
